module.exports = __webpack_public_path__ + "img/top.defc20ab.png";